// src/components/programs/FormAddEditProgram.jsx

import React from "react";
import { Box } from "@mui/material";
import ProgramFormWrapper from "./ProgramForm/ProgramFormWrapper";

/**
 * Main Program Form Component
 * Entry point for creating/editing programs
 */
const FormAddEditProgram = ({
    currentData = null,
    isEdit = false,
    onSubmitSuccess
}) => {
    return (
        <Box>
            <ProgramFormWrapper
                isEdit={isEdit}
                currentData={currentData}
                onSubmitSuccess={onSubmitSuccess}
            />
        </Box>
    );
};

export default FormAddEditProgram;
